import { z } from "zod";

import { DEFAULT as DEFAULT_SETTINGS, type Settings } from "../../../components/widget-form/time-series-chart/settings";
import { object, partial, tuple } from "../../_decoders";
import { Encoder } from "../../_encoder";
import { decoder as legendDecoder, encoder as legendEncoder } from "../legend/spec";
import { decoder as thresholdsModeDecoder, encoder as thresholdsModeEncoder } from "../thresholds/mode-spec";
import { decoder as thresholdsStepsDecoder, encoder as thresholdsStepsEncoder } from "../thresholds/steps-spec";

const decoder = object({
	0: z.string().optional().catch(undefined),
	1: z.number().optional().catch(undefined),
	2: z.boolean().optional().catch(undefined),
	3: z.number().optional().catch(undefined),
	4: z.number().optional().catch(undefined),
	5: legendDecoder,

	6: tuple([z.boolean().optional().catch(undefined), z.string().optional().catch(undefined)])
		.transform(([show, label]) => partial({ show, label }))
		.catch(undefined),

	7: tuple([thresholdsModeDecoder, thresholdsStepsDecoder])
		.transform(([mode, steps]) => partial({ mode, steps }))
		.optional()
		.catch(undefined),
})
	.transform((fields) =>
		partial<Settings>({
			unit: fields[0],
			decimals: fields[1],
			connectNulls: fields[2],
			min: fields[3],
			max: fields[4],
			legend: fields[5],
			yAxis: fields[6],
			thresholds: fields[7],
		}),
	)
	.catch(undefined);

function encoder({ unit, decimals, connectNulls, min, max, legend, yAxis, thresholds }: Settings): Encoder {
	return Encoder.shape({
		0: Encoder.primitive(unit, DEFAULT_SETTINGS.unit),
		1: Encoder.primitive(decimals, DEFAULT_SETTINGS.decimals),
		2: Encoder.primitive(connectNulls, DEFAULT_SETTINGS.connectNulls),
		3: Encoder.primitive(min, DEFAULT_SETTINGS.min),
		4: Encoder.primitive(max, DEFAULT_SETTINGS.max),
		5: legendEncoder(legend),
		6: Encoder.tuple(
			Encoder.primitive(yAxis?.show, DEFAULT_SETTINGS.yAxis.show),
			Encoder.primitive(yAxis?.label, DEFAULT_SETTINGS.yAxis.label),
		),
		7: Encoder.tuple(
			thresholdsModeEncoder(thresholds?.mode, DEFAULT_SETTINGS.thresholds.mode),
			thresholdsStepsEncoder(thresholds?.steps, DEFAULT_SETTINGS.thresholds.steps),
		),
	});
}

export { decoder, encoder };
